import React from "react";
import { Tag } from "antd";

const getDecimalPrecision = () => {
  try { const s = localStorage.getItem("global_decimal_precision"); return s ? parseInt(s, 10) : 3; } catch { return 3; }
};

const formatCurrency = (amount) => {
  const dp = getDecimalPrecision();
  if (amount == null) return `$0.${"0".repeat(dp)}`;
  const value = parseFloat(amount);
  return `$${value.toLocaleString("en-US", {
    minimumFractionDigits: dp,
    maximumFractionDigits: dp,
  })}`;
};

// Column definitions for overpayment detail header table
const getOverpaymentDetailColumns = (allocationStatus) => [
  {
    title: "Partner",
    dataIndex: "partner_name",
    key: "partner_name",
    width: 150,
    ellipsis: true,
  },
  {
    title: "Transaction Reference",
    dataIndex: "transaction_reference",
    key: "transaction_reference",
    width: 200,
    ellipsis: true,
    render: (text) => text || "N/A",
  },
  {
    title: "Type",
    key: "type",
    width: 80,
    render: (_, record) => {
      // Check transaction detail field for DEBIT/CREDIT
      const detail = record.transaction_detail || record.detail;
      if (detail === "DEBIT") {
        return <Tag color="red">Debit</Tag>;
      } else if (detail === "CREDIT") {
        return <Tag color="green">Credit</Tag>;
      }
      // Fallback: infer from amount
      // Positive = DEBIT (money you paid out, e.g., overpaid a vendor)
      // Negative = CREDIT (money received, e.g., customer overpaid you)
      const amount = parseFloat(record.amount || 0);
      if (amount > 0) {
        return <Tag color="red">Debit</Tag>;
      } else if (amount < 0) {
        return <Tag color="green">Credit</Tag>;
      }
      return <Tag>-</Tag>;
    },
  },
  {
    title: "Date",
    dataIndex: "transaction_date",
    key: "transaction_date",
    width: 100,
  },
  {
    title: "Amount",
    dataIndex: "amount",
    key: "amount",
    width: 120,
    render: (amount) => formatCurrency(amount),
  },
  {
    title: "Allocated",
    key: "allocated",
    width: 120,
    render: (_, record) => {
      const amount = parseFloat(record.amount || 0);
      const remaining = parseFloat(record.remaining_amount || 0);
      const allocated = Math.abs(amount) - Math.abs(remaining);
      return formatCurrency(allocated);
    },
  },
  {
    title: "Remaining",
    dataIndex: "remaining_amount",
    key: "remaining_amount",
    width: 120,
    render: (amount) => formatCurrency(amount),
  },
  {
    title: "Status",
    key: "status",
    width: 130,
    render: () => {
      if (!allocationStatus) return <Tag>Unknown</Tag>;
      return (
        <Tag color={allocationStatus.color === "success" ? "green" : allocationStatus.color === "warning" ? "orange" : "default"}>
          {allocationStatus.label}
        </Tag>
      );
    },
  },
];

export default getOverpaymentDetailColumns;
